import { api } from "./api";

const store = new Map();

export async function cachedGet(path, ttlMs = 45000) {
  const hit = store.get(path);
  if (hit && Date.now() - hit.at < ttlMs) return hit.data;
  const res = await api.get(path);
  store.set(path, { data: res.data, at: Date.now() });
  return res.data;
}

export function invalidateCache(prefix) {
  for (const k of [...store.keys()]) {
    if (k.startsWith(prefix)) store.delete(k);
  }
}
